import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import foto_presidente from '../../assets/pr_ispa.jpg';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Palavra do Presidente' }
];


function Palavra_do_presidente() {
    return (
        <>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
            title="Mensagem do Presidente"
            subtitle="Palavra do Presidente do Instituto Superior Politécnico Atlântida"
            description={`A mensagem do presidente do Instituto Superior Politécnico Atlântida reflete o compromisso com a excelência acadêmica e a responsabilidade social.`}
            backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
            backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <br />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Instituição"
                            items={[
                            { label: "Apresentação", href: "/instituicao" },
                            { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                            { label: "Organigrama", href: "/instituicao/organigrama" },
                            { label: "Legalidade", href: "/instituicao/legalidade" },
                            { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                            { label: "Apoio Social", href: "/instituicao/apoio-social" },
                            { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                            { label: "Decretos", href: "/instituicao/decretos" },
                            { label: "Regulamento", href: "/instituicao/regulamentos" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-9 col-xxl-9">
                        <br />
                        <div className="details-magazine">
                            <p className="f-reg">
                            <SectionHeading title="Palavra do Presidente" />
                            </p>
                            <p className="f-reg">
                                <b>Caros amigos e membros da nossa comunidade,</b><br /><br />
                                É com grande entusiasmo e orgulho que hoje me dirijo a vocês para apresentar nossa querida instituição. Como presidente, é uma honra compartilhar o que fazemos e, mais importante, por que isso importa.<br /><br />
                                Nossa instituição não é apenas um lugar; é um lar para ideias que transformam vidas. Aqui, cada um de nós encontra não apenas um propósito, mas uma comunidade unida por um objetivo comum: fazer a diferença.<br />
                                Nós não somos apenas um centro de aprendizagem ou um espaço de encontro. Somos uma fonte de inspiração, um catalisador para mudanças positivas. Aqui, você não é apenas um membro; você é parte de uma jornada coletiva para construir um futuro melhor.<br /><br />
                                Convidamos você a fazer parte desta jornada. Juntos, podemos criar impacto, cultivar talentos e moldar o amanhã. Na nossa instituição, encontramos não apenas conhecimento, mas também compaixão, não apenas habilidades, mas também solidariedade.<br /><br />
                                Seja você um estudante buscando conhecimento, um profissional em busca de crescimento ou um cidadão com um desejo de servir, aqui você encontrará um lar. Um lar onde as ideias florescem, onde os sonhos se realizam e onde cada indivíduo é valorizado.<br /><br />
                                Portanto, venha nos visitar, participe de nossos programas, junte-se às nossas iniciativas. Juntos, podemos criar um impacto significativo em nossas vidas e na comunidade ao nosso redor.<br /><br />
                                <b>Obrigado.</b>
                            </p>
                            <br />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-3 col-xl-3 col-xxl-3">
                        <div className="mb-4">
                            <img src={foto_presidente} alt="Presidente do Ispa" className="img-fluid rounded shadow" />
                        </div>
                    </div>
                </div>
                <br /><br /><br />
            </main>
            <AppLayout />
        </>
    );
}

export default Palavra_do_presidente;
